import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { ExternalAccountsPanelComponent } from './lib/external-accounts-panel.component'
import { ExternalAccountsPanelKey } from './panel-key'

export * from './lib/external-accounts.module'
export * from './panel-key'

export const ExternalAccountsPanelConfig: PanelConfig = {
  key: ExternalAccountsPanelKey,
  title: 'My Accounts',
  description:
    'Select aggregates or other accounts to load a dashboard report. View reconciliation status and load into accounts. ',
  category: PanelCategory.ESSENTIALS,
  panelComponent: ExternalAccountsPanelComponent,
  accessPermission: 'accessExternalAccountsPanel',
  isExternal: true,
}
